module.exports = __webpack_public_path__ + "static/media/Rotated tooth12.e472d817.png";